import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const ZoomModalImage = styled.img<{ width: number }>`
  width: ${(props) => props.width * Screen.widthRatio}px;
  position: absolute;
  margin: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default withImage(ZoomModalImage);
